import { Form, Grid, pn, useElementBreakpoints } from "@compass/core";
import { DatePicker, Select, SubmitButton } from "components";
import { ContributorMatchFilter, ContributorMatchFilterResource } from "generated/openApi";
import produce from "immer";
import "moment-timezone";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const MatchFilter = (props: {
  filter: ContributorMatchFilter;
  setFilter: (value: ContributorMatchFilter) => void;
}) => {
  const { breakpointsRef, xSmallFieldBreakpoints, smallFieldBreakpoints } = useElementBreakpoints();
  const [filter, setFilter] = useState<ContributorMatchFilter>(props.filter);
  const [resource, setResource] = useState<ContributorMatchFilterResource>({});
  const properties = resource.properties || [];

  useEffect(() => {
    ApiService.contributorMatches.getFilterResource().then((response) => {
      setResource(response);
    });
  }, []);

   useEffect(() => {
    if (filter) {
      props.setFilter(filter);
    }
  }, [filter]);

    const serviceTypeField = () => {
        const propertyName = pn<ContributorMatchFilter>("serviceId");
        const property = properties.find((x) => x.propertyName === propertyName);

        return (
            <Select
                modelProperty={property}
                value={resource.services?.find((x) => x.id === filter?.serviceId)}
                options={resource.services}
                getOptionLabel={(option) => option.name}
                onChange={(e, value) => {
                    setFilter(
                        produce((draft) => {
                            draft.serviceId = value?.id;
                        })
                    );
                }}
                size="small"
                label="Service Types" 
            />
        );
    };

  const dateFromField = () => {
    const propertyName = pn<ContributorMatchFilter>("dateFrom");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <DatePicker
        modelProperty={property}
        value={filter.dateFrom}
        onChange={(value) => {
            setFilter(
                produce((draft) => {
                    draft.dateFrom = value;
                })
            );
        }}
        size="small"
      />
    );
  };

  const dateToField = () => {
    const propertyName = pn<ContributorMatchFilter>("dateTo");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <DatePicker
        modelProperty={property}
        value={filter.dateTo}
        onChange={(value) => {
            setFilter(
                produce((draft) => {
                    draft.dateTo = value;
                })
            );
        }}
        size="small"
      />
    );
  };

  const clearFilter = () => {
  const clearedFilter: ContributorMatchFilter = {
    ...props.filter,
    serviceId: undefined,
    dateFrom: undefined,
    dateTo: undefined,
  };
    setFilter(clearedFilter);
};

  return (
    <Form style={{ width: "100%" }}>
      <Grid ref={breakpointsRef} container spacing="sm" alignItems="center">
        <Grid item xs={smallFieldBreakpoints}>
            {serviceTypeField()}
        </Grid>
        <Grid item xs={xSmallFieldBreakpoints}>
          {dateFromField()}
        </Grid>
        <Grid item xs={xSmallFieldBreakpoints}>
          {dateToField()}
        </Grid>
       {(filter.serviceId || filter.dateFrom || filter.dateTo) && (
          <Grid item alignItems="center">
            <SubmitButton 
              label="Clear" 
              variant="outlined" 
              onClick={clearFilter} 
            />
          </Grid>
        )}
      </Grid>
    </Form>
  );
};
